module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-logo-sk-d23806f1f96f551099b806407c49bf27.svg";